var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailedTag = function SvgFailedTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.d,.e{stroke:#171926;}.c{stroke-width:1.5px;}.d,.e{fill:#171926;}.d{stroke-width:0.6px;}.e{stroke-linejoin:round;stroke-width:2px;}.f{stroke:none;}.g{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 13,
    transform: "translate(0.076 0.076)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.076 -0.076)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#171926",
    strokeWidth: "1.5px",
    fill: "#fff",
    d: "M7.778,0,11,3.222V7.778L7.778,11H3.222L0,7.778V3.222L3.222,0Z",
    transform: "translate(1.076 1.076)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.571 3.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-23498.73-22471.279l-.27-2.719h1.354l-.275,2.719Z",
    transform: "translate(23499.516 22473.998)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(0 3.528)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.192,
    cy: 1.192,
    r: 1.192
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.192,
    cy: 1.192,
    r: 0.192
  }))))));
};
export default SvgFailedTag;